export class RespMenu { 
    constructor({menuId, menuName, icon, active, items=[], parent, link, sequence}) {
        this.menuId = menuId
        this.menuName = menuName
        this.icon = icon
        this.active = active
        this.items = items
        this.parent = parent
        this.link = link
        this.sequence = sequence
    }
}

export class ReqMenu { 
    constructor({menuId, level, menuName, sequence, icon, upperId, link=""}) {
        if(menuId !== undefined)
            this.menuId = menuId
        this.level = level
        this.menuName = menuName
        this.sequence = sequence
        if(icon !== undefined)
            this.icon = icon
        if(upperId !== undefined)
            this.upperId = upperId
        this.link = link
    }
    /*
    constructor(companyName) {
        this.companyName = companyName;
    }
    */

    fromJson(jsonDate) {
        if(jsonDate.menuId !== undefined)
            this.menuId = jsonDate.menuId
        this.level = jsonDate.level
        this.menuName = jsonDate.menuName
        this.sequence = jsonDate.sequence
        if(jsonDate.icon !== undefined)
            this.icon = jsonDate.icon
        if(jsonDate.upperId !== undefined)
            this.upperId = jsonDate.upperId
        this.link = jsonDate.link===undefined?"":jsonDate.link
    }

    toString() {
        return 'Name: '+this.fullName+', Age:'+this.age
    }
}
